import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { Button, Spinner } from "reactstrap";
import apiRoutes from "../../../api/ApiRoutes";
import ApiCall from "../../../api/network";
import Header from "../../../components/Header/Navbar/Header";
import Title from "../../../components/Title";
import {
  redirectToOrganizationDomain,
  GetLogInInfo,
  RemoveCookie, checkAndRedirectToOrganizationDomain, removeSharedCookie,
} from "../../../hooks/saveTokenDomain";
import { logInValidations } from "../../../validation";
import WebRoutes from "../../WebRoutes";
import { HomePageBottomIcons } from "../HomePage/HomePageBottomIcons";
import "./sign-in.scss";
import {AI, RI} from "../../../common/Icons";
import {InputComponent} from "../../../components/Input/InputComponent";
import AskPaymentModal from "../../../components/AskPaymentModal";

const initialStateForm = {
  email: "",
  password: "",
};

export const SignInPage = () => {
  const { search, state } = useLocation();
  const navigate = useNavigate();
  const [linkLoading, setLinkLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const hasLogout = urlParams.has('logout');
    const hasRedirect = urlParams.has('redirect');

    if (hasLogout && !hasRedirect) {
      removeSharedCookie();
    }
    else if (search && search !== "" && search !== null && search !== undefined) {
      checkAndRedirectToOrganizationDomain();
    }
    else {
      removeSharedCookie();
      RemoveCookie();
    }
    // eslint-disable-next-line
  }, []);

  const [formInput, setFormInputs] = useState(initialStateForm);
  const [submitCalled, setSubmitCalled] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  // /register and /general-subscription hand off the sign-up response here when
  // the email still needs verifying, so the "Verify Your Email" card below shows
  // straight away (its Resend link needs the token that response carries).
  const [user, setUser] = useState(state?.unverifiedUser);
  const [askForPayment, setAskForPayment] = useState(false)


  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormInputs({ ...formInput, [name]: value });
    if (submitCalled) {
      setValidations({ ...formInput, [name]: value });
    }
  };

    const iconColor = "gray";
    const iconSize = "18px";
    const togglePassword = () => {
        setShowPassword(!showPassword);
    }

  const resendEmailVerification = async () => {
    try {
        setLinkLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_TRIP_MERCHANT_API_KEY}/member/email/verification-notification`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.meta.token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Email resend failed. Please try again.");
      }

      const data = await response.json();
      toast.success(data?.data);
    } catch (error) {
      toast.dismiss();
      toast.error(
        "Verification failed. Please check your email and try again."
      );
      console.error("Verification failed:", error);
    } finally {
        setLinkLoading(false);
    }
  };
  const signInHandler = async () => {
    setValidations(formInput);
    setLoading(true);
    let formDataApi = new FormData();
    formDataApi.append("email", formInput.email);
    formDataApi.append("password", formInput.password);
    const response = await ApiCall.any(apiRoutes.signInMember, {}, formDataApi);
    if (response?.status === 1) {
      toast.dismiss();
      if (response?.data?.email_verified) {
          const token = response?.meta?.token;
          localStorage.setItem("token", token);
          localStorage.setItem("responseUser", JSON.stringify(response));
          toast.success("Logged in successfully. Taking you to the site...");
          // Payment is disabled, so /payment would only bounce straight back
          // out via redirectToOrganizationDomain - go there directly instead.
          redirectToOrganizationDomain(response);
          // Leave the spinner running: the browser is still navigating away,
          // and clearing `loading` here flashes the live form for a frame.
          return;
      } else {
        // Unverified email: keep the member out - no token is stored, and the
        // "Verify Your Email" screen below takes over until they verify.
        localStorage.removeItem("token");
        localStorage.removeItem("responseUser");
        toast.error("Please verify your email address before logging in.");
        setUser(response);
        setLoading(false);
      }
    }
    setLoading(false);
  };

  const setValidations = (form) => {
    const errors = logInValidations(form);
    setErrors(errors);
  };

  const handleSkip = async () => {
      setAskForPayment(false);
      await startTrail();
      redirectToOrganizationDomain(user);
      setSubmitCalled(true);
      toast.success(user?.message || "Successfully logged in.");
  };

  const startTrail = async () => {
      await fetch(`${process.env.REACT_APP_TRIP_MERCHANT_API_KEY}/stripe/start-trail`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`, // assuming sanctum/JWT
          },
      });
  }
  return (
    <>
      <Title title="Trip Merchant | Log In" />

      <div className="full-screen-bg" style={{ minHeight: "100vh" }}>
        <Header
          light={true}
          hide={true}
          organizationWebLinks={true}
          link={"register"}
          class_Name="header-bg-transparent"
        />
        <div className="container main-container d-flex justify-content-between flex-column">
          {/* <AuthHeader color="#e16e44" /> */}
          {user && !user?.data?.email_verified ? (
            <div>
              <div className="d-flex row justify-content-center signin-form-container">
                <div className="signup-fields-container my-3 d-block col-11 col-sm-10 col-md-8 col-lg-5 text-white">
                  <p className="signin-heading">Verify Your Email </p>
                  <p className="">
                    Please verify your email. We have sent a verification link
                    to your email.{" "}
                  </p>
                  <p className="">
                    if you did not receive an email, please click on resend
                    link!
                  </p>

                  <Button
                    className="button mb-1"
                    type="submit"
                    onClick={() => {
                      setUser(null);
                      // Drop the handed-off sign-up response so a refresh lands
                      // on the log in form rather than back on this card.
                      navigate(WebRoutes.signin, { replace: true, state: null });
                    }}
                    // disabled={loading}
                  >
                    {loading ? <Spinner /> : "Back to Log In"}
                  </Button>
                  <div className="d-flex row justify-content-between">
                    {/* <div
                  className="d-flex col-sm-6 align-items-center"
                  style={{ height: "20px" }}
                >
                  <input
                    autoComplete={false}
                    className="checkbox"
                    type="checkbox"
                    id="vehicle3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label className="checkbox-text">Remember Me</label>
                </div> */}
                    <div /* className="col-sm-6 d-flex justify-content-md-end signup-text m-0 " */
                      className="mt-1 d-flex justify-content-between"
                    >
                      {/* <Link
                        to={WebRoutes.signin}
                        className=" m-0 p-0 mt-1 text-unselectable text-white"
                      >
                        Forgot Password?
                      </Link> */}
                      {user && (
                        <div
                          onClick={() => !linkLoading ? resendEmailVerification() : undefined}
                          // to={WebRoutes.forgetPassword}
                          className=" m-0 p-0 mt-1 text-unselectable text-white"
                        >
                            {linkLoading ? (
                                <>
                                    Sending email verification link... <Spinner size="sm" />
                                </>
                            ) : (
                                'Resend Email Verification?'
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <form onSubmit={signInHandler}>
              <div className="d-flex row justify-content-center signin-form-container">
                <div className="signup-fields-container my-3 d-block col-11 col-sm-10 col-md-8 col-lg-5 text-white">
                  <p className="signin-heading">Log In</p>
                  <div
                    className={`d-flex flex-column align-self-start input-error-container ${
                      errors?.email ? "mb-0" : ""
                    }`}
                  >
                    <input
                      autoComplete="off"
                      onChange={onChangeHandler}
                      value={formInput?.email}
                      className="signin-input"
                      name="email"
                      placeholder="Email"
                      type="email"
                    />
                    {errors?.email ? (
                      <h6 className="mt-1 text-danger error-style text-start">
                        {errors?.email}
                      </h6>
                    ) : null}
                  </div>
                    <div
                        className={`d-flex flex-column align-self-start input-error-container  ${
                            errors?.password ? "mb-0" : ""
                        }`}
                    >
                        <div className="d-flex align-items-center align-self-start input-container justify-content-between  w-100"
                        style={{ backgroundColor: "#333", border:'none', paddingTop: '0px', paddingBottom: '0px', paddingLeft: '0px' }}>
                            <input
                                autoComplete="off"
                                onChange={onChangeHandler}
                                value={formInput?.password}
                                className="signin-input flex-grow-1"
                                name="password"
                                placeholder="Password"
                                type={showPassword ? "text" : "password"}
                                style={{border: "none",}}
                            />
                            <div
                                className="ms-2 "
                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                onClick={togglePassword}
                            >
                                {!showPassword ? (
                                    <AI.AiFillEye color={iconColor} size={iconSize} />
                                ) : (
                                    <AI.AiFillEyeInvisible color={iconColor} size={iconSize} />
                                )}
                            </div>
                        </div>
                        {errors?.password && (
                            <h6 className="mt-0 pb-0 text-danger error-style text-start">
                                {errors?.password}
                            </h6>
                        )}
                    </div>

                    <Button
                    className="button mb-1"
                    type="submit"
                    onClick={signInHandler}
                    disabled={loading}
                  >
                    {loading ? <Spinner /> : "Log In"}
                  </Button>
                  <div className="d-flex row justify-content-between">
                    {/* <div
                  className="d-flex col-sm-6 align-items-center"
                  style={{ height: "20px" }}
                >
                  <input
                    autoComplete={false}
                    className="checkbox"
                    type="checkbox"
                    id="vehicle3"
                    name="vehicle3"
                    value="Boat"
                  />
                  <label className="checkbox-text">Remember Me</label>
                </div> */}
                    <div /* className="col-sm-6 d-flex justify-content-md-end signup-text m-0 " */
                      className="mt-1 d-flex justify-content-between"
                    >
                      <Link
                        to={WebRoutes.forgetPassword}
                        className=" m-0 p-0 mt-1 text-unselectable text-white"
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                  <div>
                    <p className="signup-text">
                      New to Trip Merchant?
                      <Link
                        to={WebRoutes.signup}
                        className="text-unselectable text-white"
                      >
                        {" "}
                        Register Now
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </form>
          )}
          <div className="d-flex mt-2 flex-row justify-content-end align-items-center">
            <HomePageBottomIcons />
          </div>
        </div>
      </div>
      <AskPaymentModal open={askForPayment} close={setAskForPayment} size='lg' handleSkip = {handleSkip} user={user}/>
    </>
  );
};
